export default __webpack_public_path__ + "static/media/10.40e60005.png";